import React, { useMemo, useRef, useState } from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { Form, FormText, FormSubmit, FormNumber, FormHiddenText, FormatLabel, FormYesNo, FormURL, FormHiddenBool } from '../../../../../../shared/form/form'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { useSelectValue } from '../shared/hooks'
import { RichTextEditor, useEditorValue } from './rich-text-editor/rich-text-editor'
import { Menu, MenuDelete, MenuItem } from '../../../../../../shared/menu/menu'
import { IconEdit, IconVersion } from '../../../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useRoleSysApp } from '../../../../../../role/hook/role-sys'
import { useApiFormAppVersion } from '../../../../../../api-new/state/config'
import { StorageFileDetails } from '../../../../../../shared/transfer/storage-file-details'
import { useApiFormFileBuild } from '../../../../../../api-new/state/storage'
import { TransferFileUploadAppVersion } from '../../../../../../shared/transfer/components/transfer-file-upload-app-version'

export const AppVersionEdit = () => {
  const { appID, appStoreID, appVersionID } = useParamsInt()

  const refDetails = useRef()

  const apiFormAppVersion = useApiFormAppVersion()

  const roleSysApp = useRoleSysApp()

  const handlePath = () => apiFormAppVersion.get(appVersionID)

  const handleSubmit = async data => {
    await apiFormAppVersion.put(data.id, data)
    await apiFormAppVersion.get(appVersionID)
  }

  const [useRemoteURL, updateUseRemoteURL] = useSelectValue(apiFormAppVersion.form.useRemoteURL)
  const showStorageURL = useMemo(() => !!apiFormAppVersion.form.storageURL, [apiFormAppVersion.form])

  const [notesRaw, updateNotesValue] = useState()
  const [notesHTML, updateNodeHTML] = useState()
  const [notesTML, updateNodesTML] = useState()

  let editorValue = useEditorValue(apiFormAppVersion.form.notesRaw)

  const handleEditorUpdate = (value, valueHTML, valueTMP) => {
    // try {
    //   let hold = JSON.parse(value)
    //   debugger
    // } catch {
    //   debugger
    // }

    updateNotesValue(value)
    updateNodeHTML(valueHTML)
    updateNodesTML(valueTMP)
  }

  const HeaderMenu = () =>
    <Menu>
      <MenuItem
        Icon={IconVersion}
        text="version"
        to={`/admin/app/edit/${appID}/store/edit/${appStoreID}/version/edit/${appVersionID}/version`}
        show={roleSysApp.accessUpdate}
      />
      <MenuDelete to={`/admin/app/edit/${appID}/store/edit/${appStoreID}/version/edit/${appVersionID}/delete`} show={roleSysApp.accessDelete} />
    </Menu>

  const handleComplete = () => {
    apiFormAppVersion.get(appVersionID)
    refDetails.current.reload()
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconEdit} text={apiFormAppVersion.form.name} onPath={handlePath}>
        <CardFullHeightScrollY title={apiFormAppVersion.form.name} HeaderMenu={HeaderMenu}>
          <Form state={apiFormAppVersion.form} onSubmit={handleSubmit}>
            <FormHiddenText name="notesRaw" value={notesRaw} shouldDirty />
            <FormHiddenText name="notesHTML" value={notesHTML} />
            <FormHiddenText name="notesTMP" value={notesTML} />

            <FormHiddenBool name="useRemoteURL" value={useRemoteURL} shouldDirty />

            <FormText label="name" name="name" />
            <FormNumber label="code" name="code" />
            <FormYesNo label="required" name="isRequired" />
            <FormYesNo label="active" name="isActive" />

            <FormatLabel label="build download URL">
              <SelectIsRemoteURL value={useRemoteURL} onChange={updateUseRemoteURL} />
            </FormatLabel>

            <FormURL label="remote build URL" name="remoteURL" hidden={!useRemoteURL} />

            <FormURL label="storage URL" name="storageURL" readOnly hidden={!showStorageURL} />

            <FormatLabel label="notes">
              <RichTextEditor value={editorValue} onChange={handleEditorUpdate} />
            </FormatLabel>

            <FormSubmit text="save version" />
          </Form>
          {/* <Form state={apiFormAppVersion.form} onSubmit={handleSubmit}>
            <FormHiddenText name="notesRaw" value={notesRaw} shouldDirty />
            <FormHiddenText name="notesHTML" value={notesHTML} />
            <FormHiddenText name="notesTMP" value={notesTML} />

            <FormHiddenBool name="useRemoteURL" value={useRemoteURL} shouldDirty />

            <FormText label="name" name="name" />
            <FormNumber label="code" name="code" />
            <FormYesNo label="required" name="isRequired" />
            <FormYesNo label="active" name="isActive" />

            <FormatLabel label="build download URL">
              <SelectIsRemoteURL value={useRemoteURL} onChange={updateUseRemoteURL} />
            </FormatLabel>

            <FormURL label="remote build URL" name="remoteURL" hidden={!useRemoteURL} />

            <FormURL label="storage URL" name="storageURL" readOnly hidden={!showStorageURL} />

            <FormatLabel label="notes">
              <RichTextEditor initialValue={editorValue} onChange={handleEditorUpdate} />
            </FormatLabel>

            <FormSubmit text="save version" />
          </Form> */}
          {/* <StorageFileDetails
            useApiFormFile={useApiFormFileBuild}
            downloadName={downloadName}
            storageKey={apiFormAppVersion.form.storageKey}
            assetID={appVersionID}
            deleteID={apiFormAppVersion.form.id}
          /> */}
          <StorageFileDetails ref={refDetails} useApiFormFile={useApiFormFileBuild} id={appVersionID} />
          <TransferFileUploadAppVersion appVersion={apiFormAppVersion.form} onComplete={handleComplete} />
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}

const SelectIsRemoteURL = ({ value, onChange }) => {
  const handleChange = e => onChange && onChange(e.target.value === 'true')

  return (
    <select className="form-control" value={value} onChange={handleChange}>
      <option value="false">Local URL</option>
      <option value="true">Remote URL</option>
    </select>
  )
}
